module.exports = __webpack_public_path__ + "img/Otherfunctions-001.2b16166a.png";